module.exports = __webpack_public_path__ + "static/media/iconExclamationMark.0c70ffbd.svg";